export default function () {
  return {
    errors: {},
    user: {
      id: null,
      name: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      roles: ['ROLE_EDITOR'],
    },
    availableRoles: [
      {
        value: 'ROLE_EDITOR',
        label: 'Editor',
      },
      {
        value: 'ROLE_ADMIN',
        label: 'Administrador',
      },
    ],
  }
}
